import { Fragment, PureComponent, ReactNode } from 'react';
import { Patient } from '../../store/types/patient';
import { OptionItem } from '../../pages/Appointments';
import { AnimatePresence } from 'framer-motion';
import AdmitPatientDrawer from './AdmitPatientDrawer';
import { getMActiveId } from '../../store/localstorage';
import { MISC_KEYS, getItemFromMisc } from '../../store/idbHandler';
import { Ipd } from '../../api/fetchMyGenie';

interface Props {
    patient: Patient;
    closeDropdown: () => void;
}

interface State {
    isIpdEnabled: boolean;
    isAdmitPatientModalVisible: boolean;
}

class AdmitPatientAllPtButton extends PureComponent<Props, State> {
    state: State = {
        isIpdEnabled: false,
        isAdmitPatientModalVisible: false,
    };

    componentDidMount(): void {
        const myId = getMActiveId();
        if (!myId) {
            return;
        }
        getItemFromMisc<Ipd>(myId, MISC_KEYS.ipd)
            .then((i) => {
                this.setState({ isIpdEnabled: i?.enabled });
            })
            .catch(console.error);
    }

    toggleIsAdmitPatientModalVisible = () => {
        const { closeDropdown } = this.props;
        const { isAdmitPatientModalVisible } = this.state;
        this.setState({ isAdmitPatientModalVisible: !isAdmitPatientModalVisible });
        isAdmitPatientModalVisible && closeDropdown();
    };

    render(): ReactNode {
        const { patient } = this.props;
        const { isIpdEnabled, isAdmitPatientModalVisible } = this.state;
        const { toggleIsAdmitPatientModalVisible } = this;

        if (!isIpdEnabled) {
            return null;
        }

        return (
            <Fragment>
                <OptionItem
                    onClick={toggleIsAdmitPatientModalVisible}
                    label={'Admit Patient'}
                    key="admit-patient"
                />

                <AnimatePresence>
                    {isAdmitPatientModalVisible && (
                        <AdmitPatientDrawer
                            closeMe={toggleIsAdmitPatientModalVisible}
                            patient={patient}
                        />
                    )}
                </AnimatePresence>
            </Fragment>
        );
    }
}

export default AdmitPatientAllPtButton;
